import FileCopyIcon from "@mui/icons-material/FileCopy";
import ImageIcon from "@mui/icons-material/Image";
import InfoIcon from "@mui/icons-material/Info";
import LogoutIcon from "@mui/icons-material/Logout";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  Typography
} from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import Colors, { lightenHexColor } from "../../assets/helpers";
import {
  FETCH_CLIENT_WORK_PACKAGE,
  FETCH_CLIENT_WORK_PACKAGE_ACTIVITIES_TRACKING_STATUS,
  FETCH_CLIENT_WORK_PACKAGE_CURRENT_TIMESHEETS,
  FETCH_WORK_PACKAGES_FILES,
  SAVE_CLIENT_TIMESHEETS_NEW
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { QrButton } from "./WorkPackageComponent";
import WorkPackageInfoModal from "./WorkPackageInfoModal";
import QrGenerator from "./QrGenerator";
import { clockOutTimesheet } from "./ClockOutTimesheet";
import moment from "moment/moment";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

function WorkPackageView() {
  const { selectedClientData, loginData, multiLanguageData } = useSelector((state) => state?.main);
  const navigate = useNavigate();
  const LANGUAGE = ClientEnglishFallback.ClientWorkPackageView(
    multiLanguageData?.ClientWorkPackageView || {}
  );
  const {
    TEXT_ACTIVITIES,
    TEXT_SELECT_ACTIVITY_INSTRUCTION,
    TEXT_NO_DESCRIPTION_AVAILABLE,
    TEXT_PROCESSING,
    TEXT_LOGOUT,
    TEXT_PACKAGE_FILES,
    TEXT_UNKNOWN_FILE,
    TEXT_UNKNOWN_TYPE,
    TEXT_NO_FILES_AVAILABLE,
    TEXT_ONGOING_TIMESHEET_DETECTED,
    TEXT_ONGOING_TIMESHEET_MESSAGE,
    TEXT_DO_YOU_WANT_TO_CONTINUE,
    TEXT_CANCEL,
    TEXT_CONTINUE
  } = LANGUAGE;

  const [workPackageData, setWorkPackageData] = useState({});
  const packageId = useParams().workPackageid;
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activitiesLoading, setActivitiesLoading] = useState(false);
  const AccentColor = selectedClientData?.AccentColor;
  const ClientId = selectedClientData?.ClientId;
  const ClientEmployeeId = selectedClientData?.ClientEmployeeId;

  const [workPackageFiles, setWorkPackageFiles] = useState([]);
  const [packageActivities, setPackageActivities] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmModalLoading, setConfirmModalLoading] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [currentTimesheetId, setCurrentTimesheetId] = useState(null);
  const [showLogoutButton, setShowLogoutButton] = useState(false);
  const [qrGeneratorOpen, setQrGeneratorOpen] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0); // For triggering re-renders during tracking
  const [clockInLoader, setClockInLoader] = useState([]); // Activity-specific loaders
  const [fileViewerOpen, setFileViewerOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  console.log("packageActivities", JSON.stringify(packageActivities, null, 2));
  const tempSaveArray = useRef([]);
  const currentlyClockInActivity = useRef(null);
  const intervalRef = useRef(null);

  const currentTime = () => moment().format("HH:mm");

  useEffect(() => {
    const hasTrackingActivity = packageActivities.some((activity) => activity.isTracking);

    if (hasTrackingActivity) {
      // Update every minute
      intervalRef.current = setInterval(() => {
        setElapsedTime((prev) => prev + 1);
      }, 60000); // 60000ms = 1 minute
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [packageActivities]);

  // Handle local clock in state management (React Native implementation ported to web)
  const handleLocalClockIn = (updatedActivities) => {
    try {
      const updatedData = packageActivities?.map((item) => {
        const updatedItem = updatedActivities?.find(
          (obj) => obj.labourActivityId === item.labourActivityId
        );
        if (updatedItem) {
          return {
            ...item,
            ...updatedItem
          };
        }
        return item;
      });
      processData(updatedData);
      setPackageActivities(updatedData);
    } catch (error) {
      console.log("[handleLocalClockIn] Error:", error);
    }
  };

  const isAnyOnGoingTimesheet = async () => {
    try {
      const payLoad = {
        ClientId,
        ClientEmployeeId
      };
      const res = await Postrequestcall(
        FETCH_CLIENT_WORK_PACKAGE_CURRENT_TIMESHEETS,
        payLoad,
        loginData?.accessToken
      );

      if (res?.status === 200) {
        return res?.data?.data || [];
      }
      throw new Error("Failed to fetch ongoing timesheets");
    } catch (e) {
      console.log("ERROR : [isAnyOnGoingTimesheet] :", e);
      throw e;
    }
  };

  const fetchInitialData = async () => {
    try {
      const payLoad = { SearchList: [{ id: packageId ?? 0 }] };
      const res = await Postrequestcall(FETCH_CLIENT_WORK_PACKAGE, payLoad, loginData?.accessToken);
      if (res?.data?.status) {
        setWorkPackageData(res?.data?.data?.[0] || {});
      }
    } catch (e) {
      console.log("Error : [fetch_Initial_Data] : ", e);
    }
  };

  const getWorkPackageActivities = useCallback(async () => {
    try {
      const Payload = {
        JobId: workPackageData?.jobId,
        WorkPackageId: workPackageData?.id,
        ClientEmployeeId: selectedClientData?.ClientEmployeeId
      };
      setActivitiesLoading(true);
      const res = await Postrequestcall(
        FETCH_CLIENT_WORK_PACKAGE_ACTIVITIES_TRACKING_STATUS,
        Payload,
        loginData?.accessToken
      );
      if (res?.status === 200) {
        const data = res?.data?.data;
        setPackageActivities(data || []);
        processData(data);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("getWorkPackageActivities->Error: ", error);
    } finally {
      setActivitiesLoading(false);
    }
  }, [
    packageId,
    loginData?.accessToken,
    selectedClientData?.ClientEmployeeId,
    workPackageData?.id,
    workPackageData?.jobId
  ]);

  const processData = (data) => {
    const current = data?.find(
      (item) => item?.clockInTime !== "00:00" && item?.clockOutTime === "00:00"
    );
    currentlyClockInActivity.current = current ? current : null;

    // Find timesheet ID and set logout button visibility
    const timesheetId = data?.[0]?.clientTimesheetId;
    setCurrentTimesheetId(timesheetId);
    setShowLogoutButton(timesheetId > 0);
  };

  const fetchWorkPackageFiles = useCallback(async () => {
    try {
      setLoading(true);
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: false,
        SearchList: [
          {
            workPackageId: packageId
          }
        ]
      };

      const res = await Postrequestcall(FETCH_WORK_PACKAGES_FILES, obj, loginData?.accessToken);
      if (res?.status === 200) {
        const data = res?.data?.data;
        setWorkPackageFiles(data || []);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("fetchWorkPackageFiles->Error: ", error);
    } finally {
      setLoading(false);
    }
  }, [packageId, loginData?.accessToken, loginData?.userInformation?.UserId]);

  // Create timesheet for activity tracking
  const createTimesheet = async (activity, statusId = 4, skipCheck = false) => {
    try {
      setClockInLoader([activity?.labourActivityId]);
      if (!skipCheck) {
        const ongoingTimesheets = await isAnyOnGoingTimesheet();
        if (ongoingTimesheets?.length > 0) {
          setPendingAction({
            activity,
            statusId,
            ongoingTimesheets
          });
          setConfirmModal(true);
          return;
        }
      }

      const timesheetData = packageActivities?.map((item) => {
        let clockInTime = "00:00";
        let clockOutTime = "00:00";

        if (statusId === 1) {
          clockInTime = item.clockInTime !== "00:00" ? item.clockInTime : currentTime();
          clockOutTime = item.clockOutTime !== "00:00" ? item.clockOutTime : currentTime();
        } else if (activity && activity.labourActivityId === item?.labourActivityId) {
          clockInTime = currentTime();
        }

        return {
          Id: item?.clientTimesheetJobId,
          Notes: "",
          UDFields: "",
          Deleted: false,
          clockInTime,
          clockOutTime,
          ClientJobId: item?.clientJobId,
          ClientEmployeeId,
          ClientJobActivityId: item?.clientJobActivityId,
          clockInLatitude: 0,
          clockOutLatitude: 0,
          clockInLongitude: 0,
          clockOutLongitude: 0,
          ActivityUDFields: "",
          Mileage: 0,
          MileageUnit: "km"
        };
      });

      await saveTimesheet(timesheetData, statusId);
      if (statusId === 1) {
        navigate("/work-package"); // Go back to previous page
      }
    } catch (e) {
      console.log("ERROR : [createTimesheet] :", e);
    }
  };

  // Save timesheet data
  const saveTimesheet = async (timesheetData, statusId = 4, skipRefresh = false) => {
    if (timesheetData?.length === 0) return;

    // Set loaders for specific activities being saved
    const activityIds = timesheetData?.map((item) => item?.ClientJobActivityId);
    setClockInLoader(activityIds);

    try {
      const payLoad = {
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            workPackageId: packageId,
            Id: currentTimesheetId || 0,
            DateSubmitted: new Date(),
            Date: new Date(),
            TypeId: 3,
            StatusId: statusId, // 1 = 'In_Review', 2 = 'Approved', 3 = 'Rejected', 4= 'In_Progress'
            ClientId,
            Deleted: false,
            timeSheetJobList: timesheetData
          }
        ]
      };


      await Postrequestcall(SAVE_CLIENT_TIMESHEETS_NEW, payLoad, loginData?.accessToken);

      // If logging out (statusId = 1), navigate back
      if (statusId === 1) {
        navigate(-1); // Go back to previous page
      }
    } catch (e) {
      console.log("ERROR : [saveTimesheet] :", e);
    } finally {
      tempSaveArray.current = [];
      setClockInLoader([]); // Clear loaders
      if (!skipRefresh && statusId !== 1) {
        getWorkPackageActivities();
      }
    }
  };

  // Handle activity click for clock in/out
  const handleActivityClick = async (activity) => {
    // Don't allow clicking if activity is already completed
    if (
      activity.clockInTime !== "00:00" &&
      activity.clockOutTime !== "00:00" &&
      currentTimesheetId > 0
    ) {
      return;
    }

    try {
      if (currentTimesheetId > 0) {
        // If there's an active timesheet
        if (activity.isTracking) {
          // Clock out current activity
          const clockedOutActivity = await handleClockOut(activity);
          handleLocalClockIn([clockedOutActivity]);
          await saveTimesheet(tempSaveArray.current, 4, true);
        } else {
          // Clock out current and clock in new activity
          const updatedActivities = [];
          if (currentlyClockInActivity.current) {
            const clockedOutActivity = await handleClockOut(currentlyClockInActivity.current);
            updatedActivities.push(clockedOutActivity);
          }
          const clockedInActivity = await handleClockIn(activity);
          updatedActivities.push(clockedInActivity);
          handleLocalClockIn(updatedActivities);
          await saveTimesheet(tempSaveArray.current, 4, true);
        }
      } else {
        // Create new timesheet
        await createTimesheet(activity);
      }
    } catch (error) {
      console.log("ERROR : [handleActivityClick]", error);
    }
  };

  // Clock in to activity
  const handleClockIn = async (activity) => {
    const obj = {
      Id: activity?.clientTimesheetJobId,
      Notes: "",
      UDFields: "",
      Deleted: false,
      clockInTime: currentTime(),
      clockOutTime: "00:00",
      ClientJobId: activity?.clientJobId,
      ClientEmployeeId,
      ClientJobActivityId: activity?.clientJobActivityId,
      clockInLatitude: 0,
      clockOutLatitude: 0,
      clockInLongitude: 0,
      clockOutLongitude: 0,
      ActivityUDFields: "",
      Mileage: 0,
      MileageUnit: "km"
    };
    tempSaveArray.current.push(obj);
    // Return updated activity for local state management
    return {
      ...activity,
      isTracking: true,
      clockInTime: currentTime(),
      clockOutTime: "00:00"
    };
  };

  // Clock out from activity
  const handleClockOut = async (activity) => {
    const obj = {
      Id: activity?.clientTimesheetJobId,
      Notes: "",
      UDFields: "",
      Deleted: false,
      clockInTime: activity.clockInTime,
      clockOutTime: currentTime(),
      ClientJobId: activity?.clientJobId,
      ClientEmployeeId,
      ClientJobActivityId: activity?.clientJobActivityId,
      clockInLatitude: 0,
      clockOutLatitude: 0,
      clockInLongitude: 0,
      clockOutLongitude: 0,
      ActivityUDFields: "",
      Mileage: 0,
      MileageUnit: "km"
    };
    tempSaveArray.current.push(obj);

    // Return updated activity for local state management
    return {
      ...activity,
      isTracking: false,
      clockInTime: activity.clockInTime,
      clockOutTime: currentTime()
    };
  };

  // Handle QR code generation
  const handleQrGenerate = () => {
    setQrGeneratorOpen(true);
  };

  const handleQrGeneratorClose = () => {
    setQrGeneratorOpen(false);
  };

  // Handle logout/submit timesheet
  const handleLogout = () => {
    createTimesheet({}, 1, true); // StatusId 1 = In_Review (submitted)
  };

  // Handle file click to view image/PDF
  const handleFileClick = (file) => {
    const extension = "pdf" || file?.fileExtension?.toLowerCase();

    if (extension === "png" || extension === "jpg" || extension === "jpeg" || extension === "pdf") {
      setSelectedFile(file);
      setFileViewerOpen(true);
    } else {
      // For other file types, you could download or show a message
      console.log("File type not supported for preview:", extension);
    }
  };

  const handleFileViewerClose = () => {
    setFileViewerOpen(false);
    setSelectedFile(null);
  };

  // Handle confirm dialog for ongoing timesheets
  const handleConfirmContinue = async () => {
    try {
      setConfirmModalLoading(true);

      if (pendingAction && pendingAction.ongoingTimesheets?.length > 0) {
        // Clock out ongoing timesheets first
        const results = await clockOutTimesheet(
          pendingAction.ongoingTimesheets,
          loginData?.userInformation?.UserId,
          ClientId,
          loginData?.accessToken
        );
        console.log("results", JSON.stringify(results, null, 2));
        // Check if all timesheets were successfully clocked out
        const allSuccessful = results.every((result) => result.status !== false);

        if (allSuccessful) {
          await createTimesheet(pendingAction.activity, pendingAction.statusId, true);
        }
      } else if (pendingAction) {
        // No ongoing timesheets, just proceed with the action
        await createTimesheet(pendingAction.activity, pendingAction.statusId, true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setConfirmModal(false);
      setConfirmModalLoading(false);
      setPendingAction(null);
    }
  };

  useEffect(() => {
    if (packageId && loginData?.accessToken) {
      fetchInitialData();
      getWorkPackageActivities();
      fetchWorkPackageFiles();
    }
  }, [packageId, loginData?.accessToken, getWorkPackageActivities, fetchWorkPackageFiles]);

  return (
    <Stack
      sx={{
        overflow: "hidden",
        backgroundColor: Colors.Gray94,
        borderRadius: "8px",
        border: `1px solid ${Colors.GrayTint}`,
        minHeight: "calc(100vh - 75px)"
      }}>
      <Stack
        sx={{
          backgroundColor: "white",
          padding: "10px 20px 0px 20px",
          borderRadius: "8px 8px 0px 0px"
        }}>
        <Stack style={{ gap: "5px" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
              {workPackageData?.name}
            </Typography>
            <IconButton onClick={() => setOpenInfoModal(true)}>
              <InfoIcon
                style={{
                  color: AccentColor
                }}
              />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingBottom: "15px"
            }}>
            <span>
              <Chip
                size="small"
                label={workPackageData?.statusName ? workPackageData?.statusName : "N/A"}
                sx={{
                  padding: "5px 2px",
                  borderRadius: "5px"
                }}
              />
            </span>
            <QrButton text={"Qr code"} onClick={handleQrGenerate} />
          </Box>
        </Stack>
      </Stack>
      <Stack
        sx={{
          backgroundColor: Colors.Gray94,
          padding: "10px 20px 20px 20px",
          gap: "10px"
        }}>
        <Stack style={{ gap: "5px" }}>
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            {TEXT_ACTIVITIES}
          </Typography>
          <Typography variant="body2" sx={{ color: Colors.TaupeGray }}>
            {TEXT_SELECT_ACTIVITY_INSTRUCTION}
          </Typography>
        </Stack>

        {activitiesLoading ? (
          <Box sx={{ py: 4,  justifyContent: "center",  display: "flex" }}  >
            <CircularProgress />
          </Box>
        ) : (
          <Stack style={{ gap: "10px" }}>
            {packageActivities?.map((activity, index) => {
              // Determine activity state
              const isDisabled =
                activity?.clockInTime !== "00:00" && activity?.clockOutTime !== "00:00";
              const loader =
                clockInLoader?.length > 0 && clockInLoader?.includes(activity?.clientJobActivityId);
              const btnDisable = clockInLoader?.length > 0 || isDisabled;
              const isActivityClockIn =
                activity?.clockInTime !== "00:00" && activity?.clockOutTime === "00:00";

              // Calculate elapsed time for tracking activities
              const convertToTime = moment.utc(moment(activity?.clockInTime, "HH:mm")).format();
              const elapsed = moment.utc(moment().diff(convertToTime)).format("H:mm");
              const displayTime = isActivityClockIn
                ? elapsed
                : activity?.hours == "00:00"
                  ? moment
                    .utc(moment(activity?.clockOutTime, "HH:mm").diff(convertToTime))
                    .format("H:mm")
                  : activity?.hours || "0:00";

              return (
                <Stack
                  key={activity?.id || index}
                  onClick={() => !btnDisable && handleActivityClick(activity)}
                  sx={{
                    cursor: btnDisable ? "not-allowed" : "pointer",
                    padding: "10px 10px",
                    backgroundColor: Colors.white,
                    borderRadius: "8px",
                    position: "relative",
                    border: activity?.isTracking
                      ? `2px solid ${AccentColor}`
                      : `2px solid ${Colors.Transparent}`,
                    borderLeft: activity?.isTracking
                      ? `8px solid ${AccentColor}`
                      : `8px solid ${Colors.Transparent}`,
                    opacity: btnDisable && !loader ? 0.6 : 1
                  }}>
                  <Box sx={{ alignItems: "center",  justifyContent: "space-between", display: "flex" }}>
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      {activity?.code || "N/A"}
                    </Typography>
                    {loader ? (
                      <CircularProgress size={20} sx={{ color: AccentColor }} />
                    ) : (
                      showLogoutButton && (
                        <Typography
                          sx={{
                            color: activity?.isTracking ? AccentColor : Colors.IconGray,
                            fontWeight: activity?.isTracking ? "bold" : "normal"
                          }}
                          variant="body1">
                          {displayTime}
                        </Typography>
                      )
                    )}
                  </Box>
                  <Box sx={{ alignItems: "center",  justifyContent: "space-between", display: "flex" }}>
                    <Typography
                      style={{
                        maxWidth: "90%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      }}
                      variant="body1"
                      sx={{ color: Colors.TaupeGray }}>
                      {activity?.name || TEXT_NO_DESCRIPTION_AVAILABLE}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: activity?.isTracking ? AccentColor : Colors.IconGray
                      }}>
                      {activity?.hours?.slice(0, 2) || "0"} %
                    </Typography>
                  </Box>
                </Stack>
              );
            })}

            {/* Logout Button */}
            {showLogoutButton && (
              <Button
                variant="outlined"
                disabled={clockInLoader?.length > 0}
                onClick={handleLogout}
                startIcon={<LogoutIcon />}
                sx={{
                  alignSelf: "flex-start",
                  borderColor: AccentColor,
                  color: AccentColor,
                  "&:hover": {
                    borderColor: AccentColor,
                    backgroundColor: lightenHexColor(AccentColor, 90)
                  }
                }}>
                {clockInLoader?.length > 0 ? TEXT_PROCESSING : TEXT_LOGOUT}
              </Button>
            )}
          </Stack>
        )}

        <Stack style={{ gap: "10px" }}>
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            {TEXT_PACKAGE_FILES}
          </Typography>
        </Stack>

        {loading ? (
          <Box sx={{ py: 4,  justifyContent: "center",  display: "flex" }}  >
            <CircularProgress />
          </Box>
        ) : (
          <Stack style={{ gap: "10px" }}>
            {workPackageFiles?.length > 0 ? (
              workPackageFiles?.map((file, index) => (
                <Stack
                  onClick={() => handleFileClick(file)}
                  key={file?.id || index}
                  sx={{
                    padding: "10px",
                    backgroundColor: Colors.white,
                    borderRadius: "8px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      transform: "translateY(-2px)"
                    }
                  }}>
                  <Stack direction="row" sx={{ alignItems: "center" }} spacing={2}>
                    <Stack
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "40px",
                        width: "40px",
                        borderRadius: "5px",
                        backgroundColor: lightenHexColor(AccentColor, 90)
                      }}>
                      {file?.fileExtension === "png" ||
                        file?.fileExtension === "jpg" ||
                        file?.fileExtension === "jpeg" ? (
                        <ImageIcon
                          sx={{
                            fontSize: "30px",
                            color: AccentColor
                          }}
                        />
                      ) : (
                        <FileCopyIcon
                          sx={{
                            fontSize: "30px",
                            color: AccentColor
                          }}
                        />
                      )}
                    </Stack>
                    <Stack>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {file?.fileName || TEXT_UNKNOWN_FILE}
                      </Typography>
                      <Typography
                        noWrap={true}
                        variant="body1"
                        sx={{ color: Colors.TaupeGray, width: "content-fit" }}>
                        {file?.fileExtension || TEXT_UNKNOWN_TYPE}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              ))
            ) : (
              <Box sx={{ textAlign: "center", py: 2 }}>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {TEXT_NO_FILES_AVAILABLE}
                </Typography>
              </Box>
            )}
          </Stack>
        )}
      </Stack>
      <WorkPackageInfoModal
        data={workPackageData}
        open={openInfoModal}
        onClose={() => setOpenInfoModal(false)}
        packageId={packageId}
      />

      {/* QR Generator Modal */}
      <QrGenerator
        open={qrGeneratorOpen}
        onClose={handleQrGeneratorClose}
        workPackageData={workPackageData}
        jobId={workPackageData?.jobId}
        clientId={ClientId}
      />

      {/* File Viewer Modal */}
      <Dialog
        open={fileViewerOpen}
        onClose={handleFileViewerClose}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            minHeight: "80vh",
            maxHeight: "90vh"
          }
        }}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: `1px solid ${Colors.GrayTint}`
          }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {selectedFile?.fileName || "File Viewer"}
          </Typography>
          <IconButton onClick={handleFileViewerClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: 0, overflow: "hidden" }}>
          {selectedFile?.fileExtension?.toLowerCase() === "pdf" ? (
            <iframe
              src={selectedFile?.url}
              style={{
                width: "100%",
                height: "calc(80vh - 100px)",
                border: "none"
              }}
              title={selectedFile?.fileName}
            />
          ) : (
            <Box
              sx={{
                width: "100%",
                height: "calc(80vh - 100px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: Colors.Gray94,
                overflow: "auto"
              }}>
              <img
                src={selectedFile?.url}
                alt={selectedFile?.fileName}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain"
                }}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ borderTop: `1px solid ${Colors.GrayTint}`, padding: "16px" }}>
          <Button
            onClick={handleFileViewerClose}
            variant="outlined"
            sx={{
              borderColor: AccentColor,
              color: AccentColor,
              "&:hover": {
                borderColor: AccentColor,
                backgroundColor: lightenHexColor(AccentColor, 90)
              }
            }}>
            Close
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: AccentColor,
              boxShadow: "none",
              "&:hover": {
                backgroundColor: AccentColor,
                opacity: 0.9
              }
            }}
            onClick={() => window.open(selectedFile?.url, "_blank")}>
            Open in New Tab
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Modal for Ongoing Timesheets */}
      <Dialog
        open={confirmModal}
        onClose={() => !confirmModalLoading && setConfirmModal(false)}
        maxWidth="sm"
        fullWidth>
        <DialogTitle>{TEXT_ONGOING_TIMESHEET_DETECTED}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ marginBottom: 2 }}>
            {TEXT_ONGOING_TIMESHEET_MESSAGE}
          </DialogContentText>
          <DialogContentText sx={{ marginTop: 2, fontWeight: "bold" }}>
            {TEXT_DO_YOU_WANT_TO_CONTINUE}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: Colors.GrayTint,
              color: "black"
            }}
            onClick={() => {
              setConfirmModal(false)
              setClockInLoader([])
            }}
            disabled={confirmModalLoading}>
            {TEXT_CANCEL}
          </Button>
          <Button
            onClick={handleConfirmContinue}
            disabled={confirmModalLoading}
            variant="contained"
            sx={{ backgroundColor: AccentColor, boxShadow: "none" }}>
            {confirmModalLoading ? (
              <Box sx={{ gap: 1,  alignItems: "center",  display: "flex"  }}  >
                <CircularProgress size={16} color="inherit" />
                <span>{TEXT_PROCESSING}</span>
              </Box>
            ) : (
              TEXT_CONTINUE
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
}

export default WorkPackageView;

